<template>
  <v-app id="app" class="theme--light">
    <template v-if="ready && !error">
      <router-view />
      <bodyController :triggerAdjustActive="false" />
    </template>
    <template v-if="!ready">
      <PageLoading no-text />
    </template>
    <template v-if="error">
      <AppError class="app-error--main" :try-again="true" />
    </template>
  </v-app>
</template>

<script>
import PageLoading from "@/components/global/PageLoading";
import AppError from "@/components/global/appError";
import bodyController from "@/components/global/bodyController";

export default {
  name: "App",
  data() {
    return { ready: true, error: false };
  },
  components: { PageLoading, AppError, bodyController },
};
</script>

<style lang="scss">
@import "@/styles/main";
@import "@/styles/vc-custom/app";
.app-error--main {
  &.error-page {
    min-height: 100vh !important;
  }
}
</style>
